import { Box, Grid2 as Grid, useMediaQuery, useTheme } from "@mui/material";
import { shallowEqual, useSelector } from "react-redux";
import CurrentPlan from "../dashboard/CurrentPlan";
import TotalNoc from "../dashboard/TotalNoc";
import TotalCounties from "../dashboard/TotalCounties";
import NewNoc from "../dashboard/NewNoc";
import AvailableNoc from "../dashboard/AvailableNoc";
import NocUsage from "../dashboard/NocUsage";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import QuickActions from "../dashboard/QuickActions";

const Dashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const {
    free_active: uAnalyticsFeeActive,
    nocCreatedInPeriod: uAnalyticsNocCreated,
    availableNocInPeriod: uAnalyticsAvailableNoc,
  } = useSelector(
    (state) => state[currentSession]?.user?.user?.analytics || {},
    shallowEqual,
  );

  const { monthly_restart: uTierRestartInt } = useSelector(
    (state) => state[currentSession]?.user?.tier || {},
    shallowEqual,
  );

  const { expired: uExpired } = useSelector(
    (state) => state[currentSession]?.user?.user || {},
    shallowEqual,
  );

  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));
  const tabletSize = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (uExpired === true) {
      navigate("/subscription");
    }
  }, [navigate, uExpired]);

  return (
    <>
      <Box
        sx={{
          mx: { xs: 0, xl: "auto" },
          maxWidth: { xl: "1500px" },
          width: "100%",
          my: { xs: 1, md: 2 },
          py: { xs: 1, md: 1.5 },
          backgroundColor: "#EEF2F6",
          borderRadius: { xs: 0, md: 2 },
          mb: mobileSize ? "6rem" : tabletSize ? "5rem" : 2,
        }}
      >
        <Grid
          container
          sx={{
            px: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Grid
            sx={{ width: "100%" }}
            container
            spacing={{ xs: 1, sm: 1.5, md: 3 }}
            mt={{ xs: 0, md: 0 }}
          >
            <Grid
              size={{
                xs: 12,
                sm: uTierRestartInt && uAnalyticsFeeActive ? 6 : 12,
                md: uTierRestartInt && uAnalyticsFeeActive ? 6 : 4,
                xl: uTierRestartInt && uAnalyticsFeeActive ? 6 : undefined,
              }}
            >
              <CurrentPlan />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: uTierRestartInt && uAnalyticsFeeActive ? 6 : 6,
                md: uTierRestartInt && uAnalyticsFeeActive ? 6 : 4,
                xl: uTierRestartInt && uAnalyticsFeeActive ? 6 : undefined,
              }}
            >
              <TotalNoc pp={true} />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: uTierRestartInt && uAnalyticsFeeActive ? 6 : 6,
                md: uTierRestartInt && uAnalyticsFeeActive ? 6 : 4,
                xl: uTierRestartInt && uAnalyticsFeeActive ? 6 : undefined,
              }}
            >
              <TotalCounties />
            </Grid>
            {uTierRestartInt &&
              uAnalyticsFeeActive &&
              uAnalyticsNocCreated < uAnalyticsAvailableNoc && (
                <Grid size={{ xs: 12, sm: 6, md: 6, xl: 6 }}>
                  <NewNoc />
                </Grid>
              )}
          </Grid>
          <Grid
            container
            spacing={{ xs: 1, sm: 1.5, md: 3 }}
            mt={{ xs: 2, sm: 2.5, md: 3 }}
            sx={{ width: "100%" }}
          >
            <Grid
              size={{
                xs: 12,
                md: uTierRestartInt && uAnalyticsFeeActive ? 8 : 12,
                lg: uTierRestartInt && uAnalyticsFeeActive ? 8 : 12,
              }}
            >
              <QuickActions />
            </Grid>
            {uTierRestartInt && uAnalyticsFeeActive && (
              <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                <AvailableNoc />
              </Grid>
            )}
            <Grid
              size={{
                xs: 12,
                md: uTierRestartInt && uAnalyticsFeeActive ? 12 : 12,
                lg: uTierRestartInt && uAnalyticsFeeActive ? 12 : 12,
              }}
            >
              <NocUsage />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default React.memo(Dashboard);
